import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { userListDemoData } from '../../../../data/userListDemoData';
import { useTemplate } from '../../../features/template/TemplateProvider';
import { handleLoadLoggedUserList } from './AuthManageOperation';

const AuthManageContext = createContext();
export const useAuthManage = () => useContext(AuthManageContext);

function AuthManageProvider({ children }) {
    const [reloadKey, setReloadKey] = useState(0);
    const [userList, setUserList] = useState(userListDemoData);

    const { setMessage } = useTemplate();

    // -- Load all user list that are logged in
    useEffect(() => {
        handleLoadLoggedUserList()
            .then(({ data }) => {
                setUserList(data);
            })
            .catch((err) => {
                setMessage({ type: 'error', text: err.toString(0) });
            });
    }, [setMessage, reloadKey]);

    const value = useMemo(() => {
        // --Handle Reload
        const handleReload = () => {
            setReloadKey((d) => d + 1);
            setUserList(userListDemoData);
        };

        return {
            // -- Reload Key
            reloadKey,
            setReloadKey,

            // -- auth list
            userList,
            setUserList,

            // All Handler
            handleReload
        };
    }, [userList, reloadKey]);

    return <AuthManageContext.Provider value={value}>{children}</AuthManageContext.Provider>;
}

export default AuthManageProvider;
